export function detectColumnType(key, values = []) {
  const sample = values.find((value) => value !== null && value !== undefined && String(value).trim() !== "");
  if (sample === undefined) return "text";
  const upperKey = key.toUpperCase();
  if (upperKey.includes("ID")) return "lookup";

  const sampleText = String(sample).trim();
  const looksLikeDate = /^\d{4}[-/]\d{1,2}[-/]\d{1,2}(?:[T\s].*)?$/.test(sampleText)
    || /^\d{1,2}[-/]\d{1,2}[-/]\d{2,4}$/.test(sampleText);
  if (upperKey.includes("DATE") || looksLikeDate) return "date";

  if (typeof sample === "number" || /^-?\d+(?:\.\d+)?$/.test(sampleText)) return "number";

  const unique = [...new Set(values.filter((value) => value !== null && value !== undefined && String(value).trim() !== "").map(String))];
  if (unique.length > 0 && unique.length <= 6) return "enum";
  return "text";
}
